import './index.css'
import React from 'react';
import RichEditor from '../common/RichEditor';


export default function Description(props: any) {
  const action = props.action
  const handleChange = props.handleChange
  const ticketForm = props.ticketForm

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Descripción</p>
        </div>

        <div className='tkt-form-section-item__desc'>
          <RichEditor
            disabled={!(action === 'create')}
            name='description'
            value={ticketForm.description}
            handleChange={handleChange}
          />
        </div>

      </div>
    </React.Fragment>
  );
}
